// VB6DesignerRunnable.jsx
import React, { useState, useEffect, useCallback } from "react";
import { Rnd } from "react-rnd";


import InventoryApp from "./projects/InventoryApp";

// react95 root imports (per your environment)
import {
  Window,
  WindowHeader,
  WindowContent,
  Button,
  Toolbar,
  Fieldset,
  TextField,
  GroupBox,
  List,
  Tabs,
  Tab,
  Divider,
  // Select,
  Checkbox,
  Table,
  // MenuList,
  // MenuListItem,
} from "react95";

// icons (react95 icons package)
import { Diskcopy1, FolderOpen, WindowsExplorer } from "@react95/icons";

// theme
import { ThemeProvider } from "styled-components";
import original from "react95/dist/themes/original";

/* ---------- control definitions ---------- */
const CONTROL_TYPES = {
  button: {
    label: "Button",
    // icon: <AppWizard variant="32x32_4" />,
    icon: <img src="/button.png" alt="" style={{ width: 37, height: 32 }} />,
    element: ({ text, handlers, styleProps }) => (
      <Button {...(handlers || {})} style={{ width: "100%", height: "100%", ...styleProps }}>
        {text || "Button"}
      </Button>
    ),
  },
  label: {
    label: "Label",
    icon: <img src="/label.png" alt="" style={{ width: 32, height: 32 }} />,
    element: ({ text, handlers, styleProps }) => (
      <div
        {...(handlers || {})}
        style={{
          fontSize: 12,
          textAlign: "left",
          background: "transparent",
          width: "100%",
          height: "100%",
          paddingLeft: 4,
          paddingTop: 2,
          ...styleProps,
        }}
      >
        {text || "Label"}
      </div>
    ),
  },
  textbox: {
    label: "TextBox",
    // icon: <Write1 variant="32x32_4" />,
    icon: <img src="/text.png" alt="" style={{ width: 32, height: 32 }} />,
    element: ({ text, handlers, styleProps }) => (
      <input
        type="text"
        defaultValue={text || ""}
        {...(handlers || {})}
        style={{
          width: "100%",
          height: "100%",
          border: "inset 2px #808080",
          background: "white",
          paddingLeft: 6,
          ...styleProps,
        }}
      />
    ),
  },
  combobox: {
    label: "ComboBox",
    // icon: <ReaderClosed variant="32x32_4" />,
    icon: <img src="/combo.png" alt="" style={{ width: 32, height: 32 }} />,
    element: ({ text, handlers, styleProps }) => (
      // <Select
      //   {...(handlers || {})}
      //   defaultValue={text || "Option 1"}
      //   options={[
      //     { value: "Option 1", label: "Option 1" },
      //     { value: "Option 2", label: "Option 2" },
      //     { value: "Option 3", label: "Option 3" }
      //   ]}
      //   style={{ width: "100%", height: "100%", ...styleProps }}
      // />
        <select
                {...(handlers || {})}
                defaultValue={text || "Option 1"}
                // onChange={(e) =>
                //   setFormValues({ ...formValues, category: e.target.value })
                // }
                // style={{
                //   width: "100%",
                //   padding: "4px",
                //   border: "2px inset #808080",
                //   background: "white",
                //   fontFamily: "ms_sans_serif",
                //   fontSize: 12,
                // }}
                style={{ width: "100%", height: "100%", ...styleProps }}
              >
                <option value="Electronics">Electronics</option>
                {/* <option value="Furniture">Furniture</option> */}
                </select>
    ),
  },
  checkbox: {
    label: "CheckBox",
    icon: <img src="/check.png" alt="" style={{ width: 32, height: 32 }} />,
    element: ({ text, handlers, styleProps }) => (
      <Checkbox
        {...(handlers || {})}
        defaultChecked={false}
        label={text || "CheckBox"}
        style={{ width: "100%", height: "100%", ...styleProps }}
      />
    ),
  },
  table: {
    label: "Table",
    // icon: <Mspaint variant="32x32_4" />,
    icon: <img src="/table.png" alt="" style={{ width: 32, height: 32 }} />,
    element: ({ text, handlers, styleProps }) => (
      <Table
        {...(handlers || {})}
        style={{ width: "100%", height: "100%", overflow: "auto", ...styleProps }}
      >
        <thead>
          <tr>
            <th>Column 1</th>
            <th>Column 2</th>
            <th>Column 3</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Data 1</td>
            <td>Data 2</td>
            <td>Data 3</td>
          </tr>
          <tr>
            <td>Data 4</td>
            <td>Data 5</td>
            <td>Data 6</td>
          </tr>
        </tbody>
      </Table>
    ),
  },
  frame: {
    label: "Frame",
    icon: <WindowsExplorer variant="32x32_4" />,
    // icon: <img src="/picture.png" alt="" style={{ width: 32, height: 32 }} />, 
    element: ({ text, handlers, styleProps }) => (
      <div
        {...(handlers || {})}
        style={{
          width: "100%",
          height: "100%",
          border: "2px solid",
          borderColor: "#808080 #ffffff #ffffff #808080",
          padding: "16px 10px 10px 10px",
          position: "relative",
          background: "#c0c0c0",
          ...styleProps,
        }}
      >
        <div
          style={{
            position: "absolute",
            top: -8,
            left: 8,
            background: "#c0c0c0",
            padding: "0 4px",
            fontSize: 11,
            color: "#000080",
            fontWeight: "normal",
          }}
        >
          {text || "Frame"}
        </div>
        {/* Empty container for grouping */}
      </div>
    ),
  },
  image: {
    label: "Image",
    icon: <img src="/picture.png" alt="" style={{ width: 32, height: 32 }} />,
    element: ({ text, handlers, styleProps }) => (
      <div
        {...(handlers || {})}
        style={{
          width: "100%",
          height: "100%",
          border: "2px inset #808080",
          background: "#ffffff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          ...styleProps,
        }}
      >
        {text && text.startsWith("http") ? (
          <img
            src={text}
            alt="Preview"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
            }}
          />
        ) : (
          <div style={{ fontSize: 10, color: "#808080", textAlign: "center" }}>
            Image
            <br />
            (Set URL in Caption)
          </div>
        )}
      </div>
    ),
  },
  tabs: {
    label: "Tabs",
    icon: <img src="/tabs.png" alt="" style={{ width: 32, height: 32 }} />,
    element: ({ text, handlers, styleProps }) => (
      <div {...(handlers || {})} style={{ width: "100%", height: "100%", ...styleProps }}>
        <Tabs defaultValue={0} style={{ width: "100%", height: "100%" }}>
          <Tab value={0}>Tab 1</Tab>
          <Tab value={1}>Tab 2</Tab>
          <Tab value={2}>Tab 3</Tab>
        </Tabs>
        <div style={{ padding: 8, background: "#c0c0c0", height: "calc(100% - 30px)" }}>
          <div style={{ fontSize: 11 }}>Tab content area</div>
        </div>
      </div>
    ),
  },
  statusbar: {
    label: "StatusBar",
    icon: <img src="/status.png" alt="" style={{ width: 32, height: 32 }} />,
    element: ({ text, handlers, styleProps }) => (
      <div
        {...(handlers || {})}
        style={{
          width: "100%",
          height: "100%",
          background: "#c0c0c0",
          border: "2px inset #808080",
          display: "flex",
          alignItems: "center",
          padding: "2px 4px",
          fontSize: 11,
          fontFamily: "ms_sans_serif",
          ...styleProps,
        }}
      >
        {/* <div class="status-bar" style={{bordertop: '1px solid #808080',padding: '2px 4px',fontsize: '11px',display: 'flex',gap: '4px' }}>
            <div class="status-panel">{text || "Ready"}</div>
            <div class="status-panel" style={{flex: "0 0 150px" }}>Tasks: 6 | Complete: 1</div>
            <div class="status-panel" style={{flex: "0 0 100px"}}>65% Done</div>
        </div> */}
       <div style={{ borderRight: "2px outset #808080", paddingRight: 8, marginRight: 8 }}>
          {text || "Ready"}
        </div>
        <div style={{ borderRight: "2px outset #808080", paddingRight: 8, marginRight: 8 }}>
          Panel 2
        </div>
        <div>Panel 3</div> 
      </div>
    ),
  },
};

/* ---------- helper: runtime handler compiler ---------- */
/**
 * Accepts handlers object where values are strings like:
 *   "(e) => { alert('hi') }"
 *   "function(e) { console.log(e) }"
 * Returns an object with actual function values.
 *
 * NOTE: This uses Function constructor to compile user-provided code.
 *       That runs in the page and is as powerful as eval. Use only for
 *       local / trusted usage.
 */
function compileHandlers(handlers = {}) {
  const out = {};
  for (const key in handlers) {
    const src = String(handlers[key] || "").trim();
    if (!src) continue;
    try {
      // Try to return the function value. We support arrow or function forms.
      // Wrap in parentheses to allow arrow functions.
      // e.g. "(e) => { alert('x') }"
      // Use Function constructor instead of eval for slightly more control.
      const fn = new Function(`return (${src});`)();
      if (typeof fn === "function") out[key] = fn;
    } catch (err) {
      // compile failed; skip and keep console message
      console.error("Handler compile error for", key, err);
    }
  }
  return out;
}

/* ---------- Code Window (VB6-Style with Event Dropdown) ---------- */
function CodeWindowJS({ selected, events, setEvents, controls }) {
  const [activeTab, setActiveTab] = useState("general");
  const [selectedEvent, setSelectedEvent] = useState("onClick");

  // Available events
  const availableEvents = ["onClick", "onChange", "onKeyPress", "onFocus", "onBlur", "onMouseEnter", "onMouseLeave"];

  useEffect(() => {
    if (selected) setActiveTab("events");
    else setActiveTab("general");
  }, [selected]);

  const controlEvents = (selected && events[selected.id]) || {};

  const updateEvent = (name, value) => {
    if (!selected) return;
    setEvents({
      ...events,
      [selected.id]: {
        ...(events[selected.id] || {}),
        [name]: value,
      },
    });
  };

  return (
    <Window style={{ width: "100%", height: "100%" }}>
      <WindowHeader>{selected ? `${selected.text || selected.type} - Code` : "Code Window"}</WindowHeader>
      <WindowContent style={{ padding: 6, fontSize: 12 }}>
        <Tabs value={activeTab} onChange={(v) => setActiveTab(v)} style={{ marginBottom: 6 }}>
          <Tab value="general">General</Tab>
          <Tab value="events">Events</Tab>
        </Tabs>

        <div
          style={{
            background: "#ffffff",
            borderTop: "2px inset #808080",
            height: "calc(100% - 40px)",
            overflow: "auto",
            padding: 8,
            fontFamily: "Consolas, monospace",
            fontSize: 13,
          }}
        >
          {activeTab === "general" && (
            <pre style={{ margin: 0 }}>
              <span style={{ color: "blue" }}>// Module: Form</span>
              {"\n\n"}
              <span style={{ color: "green" }}>{'/* Use JavaScript handlers. Example: (e) => { alert("hi") } */'}</span>
            </pre>
          )}

          {activeTab === "events" && (
            <>
              {!selected && <div style={{ color: "#666" }}>Select a control to edit its events.</div>}
              {selected && (
                <>
                  {/* VB6-Style Event Dropdowns */}
                  <div style={{ display: "flex", gap: 8, marginBottom: 8, background: "#c0c0c0", padding: 4 }}>
                    <div style={{ flex: 1 }}>
                      <label style={{ fontSize: 10, display: "block" }}>Object:</label>
                      <select
                        value={selected.id}
                        style={{
                          width: "100%",
                          padding: 2,
                          border: "2px inset #808080",
                          background: "white",
                          fontFamily: "ms_sans_serif",
                          fontSize: 11,
                        }}
                        disabled
                      >
                        <option value={selected.id}>{selected.text || selected.type}</option>
                      </select>
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={{ fontSize: 10, display: "block" }}>Event:</label>
                      <select
                        value={selectedEvent}
                        onChange={(e) => setSelectedEvent(e.target.value)}
                        style={{
                          width: "100%",
                          padding: 2,
                          border: "2px inset #808080",
                          background: "white",
                          fontFamily: "ms_sans_serif",
                          fontSize: 11,
                        }}
                      >
                        {availableEvents.map(event => (
                          <option key={event} value={event}>{event}</option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Event Handler Code Editor */}
                  <div style={{ marginBottom: 6 }}>
                    <div style={{ fontSize: 11, color: "#666", marginBottom: 4 }}>
                      {selected.text || selected.type}_{selectedEvent}
                    </div>
                    <textarea
                      value={(events[selected.id] && events[selected.id][selectedEvent]) || ""}
                      onChange={(e) => updateEvent(selectedEvent, e.target.value)}
                      placeholder={`(e) => { /* ${selectedEvent} handler */ }`}
                      style={{
                        width: "100%",
                        height: 280,
                        border: "1px solid #808080",
                        background: "#ffffe0",
                        fontFamily: "Consolas, monospace",
                        fontSize: 13,
                        padding: 8,
                        resize: "vertical",
                      }}
                    />
                  </div>

                  <div style={{ color: "#444", marginTop: 6 }}>
                    <em>Tip:</em> Handlers must be valid JavaScript expressions that evaluate to functions,
                    {/* e.g. <code>(e) =&gt; {{' { alert("hi") }'}}</code> or <code>function(e) {{ console.log(e) }}</code>. */}
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </WindowContent>
    </Window>
  );
}

/* ---------- Full IDE component ---------- */
export default function VB6DesignerRunnable() {
  const [currentProject, setCurrentProject] = useState(null);
  const [controls, setControls] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [runMode, setRunMode] = useState(false);
  const [events, setEvents] = useState({});
  const [generatedCode, setGeneratedCode] = useState("");
  const [jsxPreviewOpen, setJsxPreviewOpen] = useState(false);
  const [projectExplorerOpen, setProjectExplorerOpen] = useState(false);

  // floating window rects (adjusted for menu bar + toolbar)
  const [toolboxRect, setToolboxRect] = useState({ x: 16, y: 76, w: 180, h: 260 });
  const [projectExplorerRect, setProjectExplorerRect] = useState({ x: 1100, y: 76, w: 320, h: 300 });
  const [propertiesRect, setPropertiesRect] = useState({ x: 1100, y: 390, w: 360, h: 450 });
  const [codeRect, setCodeRect] = useState({ x: 920, y: 540, w: 420, h: 300 });
  const [formRect, setFormRect] = useState({ x: 220, y: 76, w: 760, h: 640 });

  const selected = controls.find((c) => c.id === selectedId);

  // Add control
  const addControl = (type) => {
    if (runMode) return;
    
    // Set default dimensions based on control type
    let width = 120;
    let height = 30;
    
    if (type === 'combobox') {
      width = 150;
      height = 30;
    } else if (type === 'checkbox') {
      width = 120;
      height = 25;
    } else if (type === 'table') {
      width = 300;
      height = 200;
    } else if (type === 'frame') {
      width = 200;
      height = 150;
    } else if (type === 'image') {
      width = 150;
      height = 150;
    } else if (type === 'menulist') {
      width = 200;
      height = 120;
    } else if (type === 'tabs') {
      width = 300;
      height = 200;
    } else if (type === 'statusbar') {
      width = 400;
      height = 25;
    }
    
    const ctrl = {
      id: Date.now(),
      type,
      x: 40,
      y: 40,
      width,
      height,
      text: CONTROL_TYPES[type].label,
      fontSize: 12,
      handlers: {}, // optional per-control default handlers stored in events as well; kept here for convenience
    };
    setControls((prev) => [...prev, ctrl]);
    setSelectedId(ctrl.id);
  };

  const updateControl = (id, data) => {
    setControls((prev) => prev.map((c) => (c.id === id ? { ...c, ...data } : c)));
  };

  // Save layout + events
  const handleSave = () => {
    const json = JSON.stringify({ controls, events }, null, 2);
    localStorage.setItem("vb6_runnable_layout", json);

    const blob = new Blob([json], { type: "application/json" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "vb6_runnable_layout.json";
    a.click();
  };

  // Load layout or file
  const handleLoad = (file) => {
    const readJSON = (text) => {
      try {
        const parsed = JSON.parse(text);
        setControls(parsed.controls || []);
        setEvents(parsed.events || {});
        setSelectedId(null);
      } catch (e) {
        alert("Invalid layout file");
      }
    };

    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => readJSON(e.target.result);
      reader.readAsText(file);
    } else {
      const json = localStorage.getItem("vb6_runnable_layout");
      if (json) readJSON(json);
      else alert("No saved layout in localStorage");
    }
  };

  // Build runtime handlers for a control id from events state
  const runtimeHandlers = useCallback(
    (ctrlId) => {
      const ev = events[ctrlId] || {};
      // keys in ev are expected to be onClick, onChange, etc.
      const compiled = compileHandlers(ev);
      return compiled;
    },
    [events]
  );

  // Generate React95 JSX (renders ThemeProvider + container + children + inline exported handlers comment)
  const generateReact95JSX = () => {
    const importLine = `import React from "react";
import { ThemeProvider } from "styled-components";
import original from "@react95/themes/original";
import { Button, TextField } from "react95";\n\n`;

    const header = `export default function GeneratedForm() {
  return (
    <ThemeProvider theme={original}>
      <div style={{ position: "relative", width: ${formRect.w}, height: ${formRect.h}, background: "#c0c0c0", border: "2px inset #808080" }}>
`;

    const children = controls
      .map((c) => {
        const style = `position: "absolute", left: ${c.x}, top: ${c.y}, width: ${c.width}, height: ${c.height}`;
        if (c.type === "button") {
          return `        <Button style={{ ${style} }}>${escapeForJSX(c.text)}</Button>`;
        } else if (c.type === "label") {
          return `        <div style={{ ${style}, fontSize: 12, paddingLeft: 4, paddingTop: 2 }}>${escapeForJSX(c.text)}</div>`;
        } else if (c.type === "textbox") {
          return `        <TextField style={{ ${style} }} defaultValue={${JSON.stringify(c.text || "")}} />`;
        }
        return `        <div style={{ ${style} }}>${escapeForJSX(c.text)}</div>`;
      })
      .join("\n");

    const footer = `
      </div>
    </ThemeProvider>
  );
}
`;

    const eventsBlock = buildEventsBlock(events, controls);

    const full = importLine + header + children + footer + "\n" + eventsBlock;
    setGeneratedCode(full);
    setJsxPreviewOpen(true);
  };

  const escapeForJSX = (s) => {
    if (typeof s !== "string") return '""';
    return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  };

  const buildEventsBlock = (evts, ctrls) => {
    let out = `/* Event handlers (JS) exported for reference. These can be wired manually in your app. \n\n`;
    Object.entries(evts).forEach(([ctrlId, ctrlev]) => {
      const ctrl = ctrls.find((c) => String(c.id) === String(ctrlId));
      const name = (ctrl && ctrl.text) || `ctrl_${ctrlId}`;
      out += `// ${name} handlers:\n`;
      Object.entries(ctrlev).forEach(([k, v]) => {
        out += `// ${k}: ${v}\n`;
      });
      out += `\n`;
    });
    out += `*/\n`;
    return out;
  };

  const downloadGenerated = () => {
    const blob = new Blob([generatedCode], { type: "text/javascript" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "GeneratedForm_React95.jsx";
    a.click();
  };

  // quick helper: add sample onClick for selected control
  const addSampleClick = (id) => {
    setEvents({
      ...events,
      [id]: {
        ...(events[id] || {}),
        onClick: `(e) => { alert("Hello from ${ (controls.find(c => c.id === id) || {}).text || "control" }"); }`,
      },
    });
  };

  // Hidden file input id:
  const fileInputId = "vb6_load_file_input";

  return (
    <ThemeProvider theme={original}>
      <div style={{ width: "100vw", height: "100vh", position: "relative", overflow: "hidden", background: "#003333" }}>
        {/* VB6-Style Menu Bar */}
        <div style={{ 
          position: "fixed", 
          top: 0, 
          left: 0, 
          right: 0, 
          height: 20, 
          background: "#c0c0c0", 
          borderBottom: "1px solid #808080",
          display: "flex",
          alignItems: "center",
          padding: "0 4px",
          fontSize: 14,
          fontFamily: "ms_sans_serif",
          zIndex: 10001
        }}>
          <div style={{ padding: "2px 8px", cursor: "pointer" }} onMouseEnter={(e) => e.currentTarget.style.background = "#000080"} onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>File</div>
          <div style={{ padding: "2px 8px", cursor: "pointer" }} onMouseEnter={(e) => e.currentTarget.style.background = "#000080"} onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>Edit</div>
          <div style={{ padding: "2px 8px", cursor: "pointer" }} onMouseEnter={(e) => e.currentTarget.style.background = "#000080"} onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>View</div>
          <div style={{ padding: "2px 8px", cursor: "pointer" }} onMouseEnter={(e) => e.currentTarget.style.background = "#000080"} onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>Project</div>
          <div style={{ padding: "2px 8px", cursor: "pointer" }} onMouseEnter={(e) => e.currentTarget.style.background = "#000080"} onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>Format</div>
          <div style={{ padding: "2px 8px", cursor: "pointer" }} onMouseEnter={(e) => e.currentTarget.style.background = "#000080"} onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>Debug</div>
          <div style={{ padding: "2px 8px", cursor: "pointer" }} onMouseEnter={(e) => e.currentTarget.style.background = "#000080"} onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>Run</div>
          <div style={{ padding: "2px 8px", cursor: "pointer" }} onMouseEnter={(e) => e.currentTarget.style.background = "#000080"} onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>Tools</div>
          <div style={{ padding: "2px 8px", cursor: "pointer" }} onMouseEnter={(e) => e.currentTarget.style.background = "#000080"} onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>Window</div>
          <div style={{ padding: "2px 8px", cursor: "pointer" }} onMouseEnter={(e) => e.currentTarget.style.background = "#000080"} onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>Help</div>
        </div>

        {/* Toolbar (below menu) */}
        <div style={{ 
          position: "fixed", 
          top: 20, 
          left: 0, 
          right: 0, 
          height: 36, 
          background: "#c0c0c0", 
          borderBottom: "2px solid #808080",
          display: "flex",
          alignItems: "center",
          padding: "0 12px",
          gap: 8,
          zIndex: 10000
        }}>
          {/* Run/Stop Group */}
          <Button size="sm" onClick={() => setRunMode((r) => !r)} style={{ minWidth: 50, padding: "2px 8px" }}>
            {runMode ? "Stop" : "Run"}  
          </Button> 
          <Button onClick={() => setCurrentProject(null)}>Stop</Button>
          
          {/* Separator */}
          <div style={{ width: 2, height: 24, background: "#808080", margin: "0 4px" }} />
          
          {/* Edit Group */}
          <Button size="sm" onClick={() => setControls([])} style={{ minWidth: 50, padding: "2px 8px" }}>
            Clear
          </Button>
          
          {/* Separator */}
          <div style={{ width: 2, height: 24, background: "#808080", margin: "0 4px" }} />
          
          {/* File Operations Group */}
          <Button size="sm" onClick={handleSave} style={{ minWidth: 60, padding: "2px 8px" }}>
            <Diskcopy1 variant="16x16_4" /> Save
          </Button>
          <input 
            id={fileInputId} 
            type="file" 
            accept=".json" 
            style={{ display: "none" }} 
            onChange={(e) => {
              if (e.target.files && e.target.files[0]) {
                handleLoad(e.target.files[0]);
              }
            }} 
          />
          <Button 
            size="sm" 
            style={{ minWidth: 60, padding: "2px 8px" }}
            onClick={() => document.getElementById(fileInputId)?.click()}
          >
            <FolderOpen variant="16x16_4" /> Load
          </Button>
          
          {/* Separator */}
          <div style={{ width: 2, height: 24, background: "#808080", margin: "0 4px" }} />
          
          {/* Code Generation Group */}
          <Button size="sm" onClick={generateReact95JSX} style={{ minWidth: 100, padding: "2px 8px" }}>
            Generate JSX
          </Button>
          
          {/* Separator */}
          <div style={{ width: 2, height: 24, background: "#808080", margin: "0 4px" }} />
          
          {/* View Group */}
          <Button size="sm" onClick={() => setProjectExplorerOpen(!projectExplorerOpen)} style={{ minWidth: 120, padding: "2px 8px" }}>
            {projectExplorerOpen ? "Hide Explorer" : "Show Explorer"}
          </Button>

          {/* Runtime Window */}
          {currentProject && (
            <Rnd default={{ x: 350, y: 50, width: 600, height: 500 }}>
              <Window style={{ width: "100%", height: "100%" }}>
                <WindowHeader>Running: {currentProject}</WindowHeader>
                <WindowContent style={{ overflow: "auto", height: "100%" }}>
                  {currentProject === "InventoryApp" && <InventoryApp />}
                </WindowContent>
              </Window>
            </Rnd>
          )}
        </div>

        {/* Draggable Form Designer */}
        <Rnd
          size={{ width: formRect.w, height: formRect.h }}
          position={{ x: formRect.x, y: formRect.y }}
          bounds="parent"
          dragHandleClassName="form-window-header"
          onDragStop={(e, d) => setFormRect((r) => ({ ...r, x: d.x, y: d.y }))}
          onResizeStop={(e, dir, ref, delta, pos) => setFormRect({ x: pos.x, y: pos.y, w: ref.offsetWidth, h: ref.offsetHeight })}
          minWidth={480}
          minHeight={320}
        >
          <Window style={{ width: "100%", height: "100%" }}>
            <WindowHeader className="form-window-header">Form Designer</WindowHeader>

            <WindowContent style={{ height: "100%", display: "flex", flexDirection: "column" }}>
              <Toolbar>
                <span style={{ fontSize: 12 }}>Designer toolbar</span>
              </Toolbar>

              <div style={{ position: "relative", flex: 1, marginTop: 8, background: "#c0c0c0", border: "2px inset #808080", overflow: "hidden", cursor: runMode ? "default" : "crosshair" }}>
                {controls.map((c) => {
                  const CompDef = CONTROL_TYPES[c.type];
                  const handlers = runtimeHandlers(c.id); // compiled functions
                  const styleProps = { fontSize: c.fontSize || 12 }; // passed into element if needed

                  if (runMode) {
                    // runtime rendering without drag handles
                    return (
                      <div key={c.id} style={{ position: "absolute", left: c.x, top: c.y, width: c.width, height: c.height }}>
                        <CompDef.element text={c.text} handlers={handlers} styleProps={styleProps} />
                      </div>
                    );
                  }

                  // Design-mode: each control is an Rnd to drag/resize
                  return (
                    <Rnd
                      key={c.id}
                      size={{ width: c.width, height: c.height }}
                      position={{ x: c.x, y: c.y }}
                      bounds="parent"
                      onDragStop={(e, d) => updateControl(c.id, { x: d.x, y: d.y })}
                      onResizeStop={(e, dir, ref, delta, pos) => updateControl(c.id, { width: ref.offsetWidth, height: ref.offsetHeight, ...pos })}
                      onClick={() => setSelectedId(c.id)}
                      style={{ border: selectedId === c.id ? "1px dashed blue" : "1px solid transparent", background: "white", padding: 2 }}
                    >
                      <CompDef.element text={c.text} handlers={runtimeHandlers(c.id)} styleProps={styleProps} />
                    </Rnd>
                  );
                })}
              </div>

              {/* Status Bar */}
              <div
                style={{
                  background: "#c0c0c0",
                  borderTop: "1px solid #808080",
                  padding: "2px 4px",
                  fontSize: 11,
                  display: "flex",
                  gap: 4,
                  marginTop: 8,
                }}
              >
                <div
                  style={{
                    border: "1px solid",
                    borderColor: "#808080 #ffffff #ffffff #808080",
                    padding: "1px 4px",
                    flex: 1,
                  }}
                >
                  {runMode ? "Run Mode" : "Design Mode"}
                </div>
                <div
                  style={{
                    border: "1px solid",
                    borderColor: "#808080 #ffffff #ffffff #808080",
                    padding: "1px 4px",
                    flex: "0 0 150px",
                  }}
                >
                  Controls: {controls.length}
                </div>
                <div
                  style={{
                    border: "1px solid",
                    borderColor: "#808080 #ffffff #ffffff #808080",
                    padding: "1px 4px",
                    flex: "0 0 200px",
                  }}
                >
                  {selected ? `Selected: ${selected.text || selected.type}` : "No selection"}
                </div>
              </div>
            </WindowContent>
          </Window>
        </Rnd>

        {/* Floating Toolbox */}
        <Rnd size={{ width: toolboxRect.w, height: toolboxRect.h }} position={{ x: toolboxRect.x, y: toolboxRect.y }} bounds="parent" onDragStop={(e, d) => setToolboxRect((r) => ({ ...r, x: d.x, y: d.y }))} onResizeStop={(e, dir, ref, delta, pos) => setToolboxRect({ x: pos.x, y: pos.y, w: ref.offsetWidth, h: ref.offsetHeight })} minWidth={140} minHeight={120}>
          <Window style={{ width: "100%", height: "100%" }}>
            <WindowHeader>Toolbox</WindowHeader>
            <WindowContent>
              <List>
                {Object.entries(CONTROL_TYPES).map(([key, ctrl]) => (
                  <div key={key} onClick={() => addControl(key)} style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 8px", cursor: runMode ? "not-allowed" : "pointer", opacity: runMode ? 0.6 : 1, border: "1px solid transparent" }} onMouseEnter={(e) => { if (!runMode) e.currentTarget.style.border = "1px solid #000"; }} onMouseLeave={(e) => { e.currentTarget.style.border = "1px solid transparent"; }}>
                    {ctrl.icon}
                    <span style={{ fontSize: 12 }}>{ctrl.label}</span>
                  </div>
                ))}
              </List>
            </WindowContent>
          </Window>
        </Rnd>

        {/* Project Explorer */}
        {projectExplorerOpen && (
          <Rnd 
            size={{ width: projectExplorerRect.w, height: projectExplorerRect.h }} 
            position={{ x: projectExplorerRect.x, y: projectExplorerRect.y }} 
            bounds="parent" 
            dragHandleClassName="drag-handle"
            onDragStop={(e, d) => setProjectExplorerRect((r) => ({ ...r, x: d.x, y: d.y }))} 
            onResizeStop={(e, dir, ref, delta, pos) => setProjectExplorerRect({ x: pos.x, y: pos.y, w: ref.offsetWidth, h: ref.offsetHeight })} 
            minWidth={200} 
            minHeight={150}
          >
          <Window style={{ width: "100%", height: "100%", background: "#e5e3e3ff" }}>
            <WindowHeader className="drag-handle">Project - Project1</WindowHeader>
            <WindowContent style={{ background: "#e8e4e4ff", padding: 4 }}>
              <div style={{ fontSize: 11, fontFamily: "ms_sans_serif" }}>
                {/* Project Tree */}
                <div style={{ marginBottom: 4 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 4, padding: 2 }}>
                    <span>📁</span>
                    <strong>Project1 (Project1)</strong>
                  </div>
                </div>
                
                <div style={{ marginLeft: 16 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 4, padding: 2 }}>
                    <span>📁</span>
                    <span>Forms</span>
                  </div>
                  
                  <div style={{ marginLeft: 16 }}>
                    <div 
                      style={{ 
                        display: "flex", 
                        alignItems: "center", 
                        gap: 4, 
                        padding: 2,
                        background: selectedId ? "transparent" : "#000080",
                        color: selectedId ? "black" : "white",
                        cursor: "pointer"
                      }}
                      onClick={() => setSelectedId(null)}
                    >
                      <span>📄</span>
                      <span>Form1 (Form1)</span>
                    </div>
                    
                    {/* Controls List */}
                    {controls.length > 0 && (
                      <div style={{ marginLeft: 16, marginTop: 4 }}>
                        <div style={{ fontSize: 10, color: "#666", marginBottom: 2 }}>Controls:</div>
                        {controls.map((control) => (
                          <div
                            key={control.id}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 4,
                              padding: "2px 4px",
                              background: selectedId === control.id ? "#000080" : "transparent",
                              color: selectedId === control.id ? "white" : "black",
                              cursor: "pointer",
                              fontSize: 10,
                            }}
                            onClick={() => setSelectedId(control.id)}
                          >
                            <span>
                              {control.type === 'button' && '🔘'}
                              {control.type === 'label' && '📝'}
                              {control.type === 'textbox' && '📝'}
                              {control.type === 'combobox' && '📋'}
                              {control.type === 'checkbox' && '☑️'}
                              {control.type === 'table' && '📊'}
                              {control.type === 'frame' && '🖼️'}
                              {control.type === 'image' && '🖼️'}
                              {control.type === 'menulist' && '📋'}
                            </span>
                            <span>{control.text || control.type}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </WindowContent>
          </Window>
        </Rnd>
        )}

        {/* Floating Properties */}
        <Rnd size={{ width: propertiesRect.w, height: propertiesRect.h }} position={{ x: propertiesRect.x, y: propertiesRect.y }} bounds="parent" onDragStop={(e, d) => setPropertiesRect((r) => ({ ...r, x: d.x, y: d.y }))} onResizeStop={(e, dir, ref, delta, pos) => setPropertiesRect({ x: pos.x, y: pos.y, w: ref.offsetWidth, h: ref.offsetHeight })} minWidth={260} minHeight={220}>
          <Window style={{ width: "100%", height: "100%", background: "#c0c0c0" }}>
            <WindowHeader>Properties</WindowHeader>
            <WindowContent style={{ background: "#c0c0c0" }}>
              {selected ? (
                <>
                  <Fieldset label="Control Info">
                    <div style={{ fontSize: 12  }}>
                      <b>Type:</b> {selected.type}
                    </div>
                  </Fieldset>

                  <GroupBox label="Properties" style={{ marginTop: 8 }}>
                    <div style={{ display: "grid", gap: 6, fontSize: 12 }}>
                      <label>
                        Caption:
                        <TextField value={selected.text} onChange={(e) => updateControl(selected.id, { text: e.target.value })} />
                      </label>

                      <label>
                        X:
                        <TextField value={selected.x} onChange={(e) => updateControl(selected.id, { x: parseInt(e.target.value) || 0 })} />
                      </label>

                      <label>
                        Y:
                        <TextField value={selected.y} onChange={(e) => updateControl(selected.id, { y: parseInt(e.target.value) || 0 })} />
                      </label>

                      <label>
                        Width:
                        <TextField value={selected.width} onChange={(e) => updateControl(selected.id, { width: parseInt(e.target.value) || 50 })} />
                      </label>

                      <label>
                        Height:
                        <TextField value={selected.height} onChange={(e) => updateControl(selected.id, { height: parseInt(e.target.value) || 20 })} />
                      </label>

                      {(selected.type === 'label' || selected.type === 'textbox') && (
                        <label>
                          Font Size:
                          <TextField value={selected.fontSize || 12} onChange={(e) => updateControl(selected.id, { fontSize: parseInt(e.target.value) || 12 })} />
                        </label>
                      )}
                    </div>
                  </GroupBox>

                  <Divider style={{ margin: "8px 0" }} />

                  <Fieldset label="Events">
                    <div style={{ display: "flex", gap: 6 }}>
                      <Button size="sm" onClick={() => setSelectedId(selected.id)}>Edit Events</Button>
                      <Button size="sm" onClick={() => addSampleClick(selected.id)}>Add Sample Click</Button>
                    </div>
                  </Fieldset>
                </>
              ) : (
                <p style={{ fontSize: 12, color: "#444" }}>Select a control to edit its properties.</p>
              )}
            </WindowContent>
          </Window>
        </Rnd>

        {/* Floating Code Window */}
        <Rnd size={{ width: codeRect.w, height: codeRect.h }} position={{ x: codeRect.x, y: codeRect.y }} bounds="parent" onDragStop={(e, d) => setCodeRect((r) => ({ ...r, x: d.x, y: d.y }))} onResizeStop={(e, dir, ref, delta, pos) => setCodeRect({ x: pos.x, y: pos.y, w: ref.offsetWidth, h: ref.offsetHeight })} minWidth={320} minHeight={240}>
          <CodeWindowJS selected={selected} events={events} setEvents={setEvents} controls={controls} />
        </Rnd>

        {/* JSX Preview Modal */}
        {jsxPreviewOpen && (
          <div style={{ position: "fixed", top: 48, left: "50%", transform: "translateX(-50%)", width: "85%", height: "80%", background: "white", border: "3px solid #000", zIndex: 9999, padding: 12, overflow: "auto" }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
              <strong>Generated React95 JSX</strong>
              <div>
                <Button size="sm" onClick={downloadGenerated} style={{ marginRight: 8 }}>Download</Button>
                <Button size="sm" onClick={() => setJsxPreviewOpen(false)}>Close</Button>
              </div>
            </div>
            <pre style={{ whiteSpace: "pre-wrap", fontSize: 12, lineHeight: 1.3 }}>{generatedCode}</pre>
          </div>
        )}
      </div>
    </ThemeProvider>
  );
}
